import { Button, Col, DatePicker, Form, Row, Space } from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { DATE_FORMAT } from '../../appContants';

const SelectInvoiceDurationForm = ({ onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  return (
    <Form
      form={form}
      onFinish={(values) => {
        onSubmit?.(values);
        form.resetFields();
      }}
      layout="vertical"
      clearOnDestroy
    >
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="From Date"
            name="fromDate"
            required
            getValueProps={(value) => ({
              value: value && dayjs(value),
              format: DATE_FORMAT
            })}
            normalize={(value) => value && `${dayjs(value).toISOString()}`}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="To Date"
            name="toDate"
            required
            getValueProps={(value) => ({
              value: value && dayjs(value),
              format: DATE_FORMAT
            })}
            normalize={(value) => value && `${dayjs(value).toISOString()}`}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item className="mt-3">
        <Space>
          <Button
            htmlType="button"
            onClick={() => {
              form.resetFields();
              onCancel?.();
            }}
          >
            Cancel
          </Button>
          <Button key="enable" type="primary" htmlType="submit">
            Submit
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
SelectInvoiceDurationForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};
export default SelectInvoiceDurationForm;
